var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col items-center w-full gap-4 py-8",
      style: { minHeight: "calc(100vh - 2.5rem - 3.5rem - 5rem)" }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-4 px-10 w-152",
          class:
            _vm.defaultProblemBehaviors.length === 0 ? "pt-10 pb-2" : "py-10"
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-between" },
            [
              _c("BlTextSubtitle1", {
                attrs: { text: "Add problem behaviors" }
              }),
              _vm._v(" "),
              !_vm.allProblemBehaviorsUsed
                ? _c("BlInputButton", {
                    attrs: { label: "Add behavior" },
                    on: { clicked: _vm.onAddProblemBehavior }
                  })
                : _c(
                    "BlTooltip",
                    {
                      attrs: {
                        tooltip:
                          "You’ve reached the limit for problem behaviors and can’t create a new one."
                      }
                    },
                    [
                      _c("BlInputButton", {
                        attrs: { label: "Add behavior", disabled: "" }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.sortedProblemBehaviors, function(problemBehavior) {
            return Array.isArray(_vm.defaultProblemBehaviors) &&
              _vm.defaultProblemBehaviors.length > 0
              ? _c(
                  "div",
                  { key: "problem-behavior-item-" + problemBehavior.key },
                  [
                    _c("ProblemBehaviorItem", {
                      attrs: {
                        problemBehavior: problemBehavior,
                        kind: "client",
                        problemBehaviors: _vm.problemBehaviors,
                        defaultProblemBehaviors: _vm.defaultProblemBehaviors,
                        readOnly: !_vm.currentUser.role.includes("admin")
                      },
                      on: {
                        update: function($event) {
                          return _vm.$emit("updateProblemBehavior", $event)
                        },
                        delete: function($event) {
                          return _vm.$emit("removeProblemBehavior", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.defaultProblemBehaviors.length === 0
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center gap-3 p-2 rounded bg-cornflower-200",
              staticStyle: { width: "39rem" }
            },
            [
              _c("BlIcon", { attrs: { icon: "Info-blue" } }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "text-cornflower-800",
                attrs: {
                  text:
                    "No problem behavior will be recorded for this target. Add one if needed."
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-504e710b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504e710b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/overlay/NewProblemOverlay.vue
// module id = null
// module chunks = 